/* FitKnicks redesign: shared behaviour for fk- sections. Loaded in layout/theme.liquid. */
(() => {
  /* ------------------------------------------------------------------------
     Size guide pop-up (snippets/fk-size-guide-modal.liquid)
     Any link to /pages/size-guide opens the pop-up instead of the page.
     Runs in the capture phase so it wins over Capital's size guide drawer.
     ------------------------------------------------------------------------ */
  const isSizeGuideLink = (link) => {
    try {
      const url = new URL(link.href, window.location.href);
      return url.origin === window.location.origin && /\/pages\/size-guide\/?$/.test(url.pathname);
    } catch (error) {
      return false;
    }
  };

  document.addEventListener('click', (event) => {
    const dialog = document.getElementById('fk-size-guide');
    if (!dialog) return;

    if (event.target.closest('[data-fk-sg-close]') || event.target === dialog) {
      dialog.close();
      return;
    }

    const link = event.target.closest('a[href]');
    if (!link || !isSizeGuideLink(link) || /\/pages\/size-guide\/?$/.test(window.location.pathname)) return;

    event.preventDefault();
    event.stopPropagation();
    dialog.showModal();
  }, true);

  /* ------------------------------------------------------------------------
     Headings never break mid-word: if a whole word doesn't fit its space,
     the heading's font size steps down until it does (to a minimum).
     ------------------------------------------------------------------------ */
  const HEADINGS = [
    '.fk-heading',
    '[id^="fk-"] h1',
    '[id^="fk-"] h2',
    '[id^="fk-"] h3',
    '[id^="fk-"] h4',
    '[class*="fk-"][class*="__title"]:not([class*="__titles"])',
    '.fk-pdp .product-details-product-title',
  ].join(',');
  const MIN_RATIO = 0.5;
  const MIN_PX = 14;

  const overflows = (el) => el.scrollWidth > el.clientWidth + 1;

  const fit = (el) => {
    el.style.fontSize = '';
    if (getComputedStyle(el).display === 'inline' || !overflows(el)) return;

    const base = parseFloat(getComputedStyle(el).fontSize);
    let low = Math.max(base * MIN_RATIO, MIN_PX);
    let high = base;
    while (high - low > 0.5) {
      const mid = (low + high) / 2;
      el.style.fontSize = `${mid}px`;
      if (overflows(el)) high = mid;
      else low = mid;
    }
    el.style.fontSize = `${Math.floor(low)}px`;
  };

  const fitAll = () => document.querySelectorAll(HEADINGS).forEach(fit);

  let frame;
  const queueFit = () => {
    cancelAnimationFrame(frame);
    frame = requestAnimationFrame(fitAll);
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', queueFit);
  else queueFit();
  if (document.fonts) document.fonts.ready.then(queueFit);
  window.addEventListener('resize', queueFit);
  document.addEventListener('shopify:section:load', queueFit);
  document.addEventListener('shopify:block:select', queueFit);
})();
